<template>
  <div class="fill-height">


    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          واحدها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>


      <v-card-text>
        <v-row>
          <v-col cols="12"
                 sm="12"
                 md="1"
                 v-if="can('newEstablishment')" class="d-inline-block">
            <v-btn class="float-right "
                   color="primary"
                   right
                   fab
                   small
                   @click="forNew()"
            >
              <v-icon>fa fa-plus</v-icon>
            </v-btn>
            <div v-if="showDialog">
              <create-establishment :is-edit.sync="isEdit" :model-items="data" :unit-list="unitList"
                                    :dialogStatus.sync="showDialog"/>
            </div>

          </v-col>
          <v-col
              cols="12"
              sm="6"
              md="3">

            <v-autocomplete
                clearable
                @click:clear="search"
                :items="buildingList"
                v-model="buildId"
                @input="handleInput"
                dense
                @change="search"
                outlined
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="3"
                 class="d-inline-flex"
          >
            <v-text-field
                clearable
                @click:clear="search"
                outlined
                dense
                placeholder="نام واحد،نام شخص،شماره موبایل،اطلاعات تکمیلی"
                v-model="searchvalue"
            />
            <v-btn fab small color="primary" @click="search" class="mr-1">
              <v-icon>mdi-cloud-search</v-icon>
            </v-btn>

          </v-col>
          <v-col cols="12"
                 sm="12"
                 md="4" class="d-inline-block mr-1">
            <b-pagination
                v-model="skip"
                :total-rows="paging.totalSize"
                :per-page=take
                first-text="اولین"
                prev-text="<"
                next-text=">"
                ellipsis-text="..."
                last-text="آخرین"
                dir="ltr"
                limit="5"
                @change="pageChangeHandler"
            />

          </v-col>
        </v-row>
        <v-row v-if="can('newEstablishment')" >
          <v-col
              cols="12"
              sm="12"
              md="2" class="mt-2">

            <label>بارگذاری فایل اکسل:</label>
          </v-col>
          <v-col cols="12" md="3" sm="12">
            <v-autocomplete
                :items="buildingList"
                v-model="buildingId"
                @input="handleInput"
                dense
                outlined
                :error-messages="getError('buildingId')"
                auto-select-first append-icon="fas fa-angle-down"
                label="انتخاب مجتمع"

            />
          </v-col>
          <v-col cols="12"
                 md="4" sm="12"
                 class="d-inline-flex"
          >

            <v-file-input
                outlined
                dense
                prepend-icon=""
                v-model="file"
                show-size
                label="اکسل شامل اطلاعات واحدها"
                :error-messages="getError('file')"
            ></v-file-input>
            <v-btn fab small color="warning" @click="upload" class="mr-1">
              <v-icon>mdi-cloud-upload</v-icon>
            </v-btn>

          </v-col>
        </v-row>
        <v-row>

        </v-row>

        <v-spacer/>
        <b-table
            v-if="can('establishmentList')"
            :items="dataItems"
            :fields="columns"
            :current-page="skip"
            :per-page=0
            stacked="md"
            show-empty
            responsive striped
        >
          <template #cell(actions)="row">
            <v-btn depressed class="mr-1" v-if="can('editEstablishment')" small color="primary"
                   @click="forEdit(row.item)">
              ویرایش
            </v-btn>
            <v-btn depressed class="mr-1" v-if="can('furtherInformation')" small color="warning"
                   :to="{name:'information',query:{id:row.item.id}}">
              اطلاعات تکمیلی
            </v-btn>

          </template>
          <template #cell(tenant)="row">
            <label>{{ row.item.tenant ? ' است' : 'نیست' }}</label>
          </template>
          <template #cell(owner)="row">
            <label>{{ row.item.owner ? ' است' : 'نیست' }}</label>
          </template>

        </b-table>


      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CreateEstablishment from './PageEdit'
import Unit_se from "./Unit_se";
import {mapMutations} from "vuex";

const stabilityStatus = Object.freeze({
  based: "مستقر است",
  leave: "ترک کرده",
  empty: "خالی است"
});
export default {
  name: 'Establishment',
  components: {
    CreateEstablishment
  },
  data() {
    return {
      stabilityStatus,
      modelId: '',
      searchvalue: '',
      model: {},
      data: {},
      showDialog: false,
      isEdit: false,
      modelAtributes: {},
      dataItems: [],
      unitList: [],
      paging: {},
      skip: 1,
      take: 10,
      buildingId: '',
      buildId: '',
      buildingList: [],
      bindingErrors: [],
      currentPage: 1,
      file: [],
      columns: [
        {key: 'unitName', label: 'نام واحد', sortable: true, sortDirection: 'desc'},
        {key: 'fullName', label: 'نام شخص', sortable: true, sortDirection: 'desc'},
        {key: 'mobile', label: 'شماره موبایل', sortable: true, sortDirection: 'desc'},
        {key: 'buildingName', label: 'مجتمع', sortable: true, sortDirection: 'desc'},
        {key: 'stabilityText', label: 'وضعیت', sortable: true, sortDirection: 'desc'},
        {key: 'owner', label: 'مالک', sortable: true, sortDirection: 'desc'},
        {key: 'tenant', label: 'مستأجر', sortable: true, sortDirection: 'desc'},
        {key: 'actions', label: 'عملیات'}
      ],

    };

  },

  mounted() {
    this.$root.$on('Establishment', () => {
      this.fillDataItems()
    })

  },

  methods: {

    handleInput(value) {
      this.$emit('input', value)
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    upload() {
      this.bindingErrors = []
      this.$progress({message: 'درحال ذخیره اطلاعات...'}, true)
      Unit_se.upload(this.file, this.buildingId).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.$snack({type: 'success', message: 'درحال ذخیره اطلاعات...'})

        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          if (response.response.data.errorFile) {
            this.$snack({type: 'error', message: response.response.data.errorMsg})
          } else {
            this.bindingErrors = response.response.data.errorDTOList;
          }


        }

      })
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),


    fetch() {
      this.searchvalue = ""
      Unit_se.getById(this.modelId).then(response => {
        this.data = response.data
        this.unitList = response.data.unitList
      })
      this.showDialog = true;
    },

    forNew: function () {
      this.model = {};
      this.modelId = '';
      this.fetch()
    },
    forEdit: function (e) {
      this.modelId = e.id;
      this.isEdit = true;
      this.fetch()
    },

    remove: function (e) {
      this.$confirm()
          .then(isDestroyed => isDestroyed &&
              Unit_se.delete(e.id).then(response => {
                if (response && response.status === 200) {
                  this.$snack({type: 'success'})
                  this.fillDataItems()
                } else {
                  this.$snack({type: 'error'})
                }
              })
          )
    },
    close() {
      this.searchvalue = ""
      this.$root.$emit('Establishment')
      this.$router.push('/home')
    },
    pageChangeHandler: function (event) {
      this.skip = event;
      this.fillDataItems();

    },
    changeStatus(model) {
      Unit_se.changeStatus(model).then(() => {
        this.fillDataItems()
      })
    },

    fillDataItems() {

      this.modelAtributes = (Unit_se.getPage(this.searchvalue, this.buildId, this.skip - 1, this.take).then(response => {
        this.modelAtributes = response.data
        this.paging = this.modelAtributes.page
        this.buildingList = this.modelAtributes.buildingList
        this.dataItems = this.modelAtributes.establishmentList

      }));
    },

    search() {
      this.skip = 1
      this.take = 10
      this.fillDataItems()
    },


  },

  created() {
    this.setDrawer(false)
    this.fillDataItems();
  }

}
</script>

<style>
.table th, .table td {
  padding: 5px !important;
}

</style>
